import { axios } from '@/utils/request'
import { mockRepaymentReport, useMock } from '@/webpublicapi/_mock'

export function findNotReceiveAmountList(parameter = {}) {
  return axios({
    url: '/order/findNotReceiveAmountList',
    method: 'post',
    data: parameter
  })
}

export function findRepairedButUnreleasedUsersList(parameter = {}) {
  return axios({
    url: '/order/findRepairedButUnreleasedUsersList',
    method: 'post',
    data: parameter
  })
}

export function getmodalTbleList (parameter = {}) {
  return axios({
    url: '/statistics/findAdCostInfos',
    method: 'post',
    data: parameter
  })
}
export function updatemodalTbleList (parameter = {}) {
  return axios({
    url: '/statistics/updateAdCost',
    method: 'post',
    data: parameter
  })
}


export function findProductMarketDatas(parameter = {}) {
  return axios({
    url: '/statistics/findProductMarketDatas',
    method: 'post',
    data: parameter
  })
}

export function getProdcutMarketDataChannelAndAd(parameter = {}) {
  return axios({
    url: '/statistics/getProdcutMarketDataChannelAndAd',
    method: 'post',
    data: parameter
  })
}

export function getAllOrderList(parameter = {}) {
  return axios({
    url: '/order/allOrderList',
    method: 'post',
    data: parameter
  })
}

export function findLoanStatusCount(parameter = {}) {
  return axios({
    url: '/order/findLoanStatusCount',
    method: 'post',
    data: parameter
  })
}

export function getOrderDetail(parameter = {}) {
  return axios({
    url: '/order/detail',
    method: 'post',
    data: parameter
  })
}

export function getOrderInfoQryList(parameter = {}) {
  return axios({
    url: '/order/orderInfoQry',
    method: 'post',
    data: parameter
  })
}

export function createRepayUrlFunc(parameter = {}) {
  return axios({
    url: '/order/createRepayUrl',
    method: 'post',
    data: parameter
  })
}

export function balanceOrderFunc(parameter = {}) {
  return axios({
    url: '/order/balanceOrder',
    method: 'post',
    data: parameter
  })
}


export function createRepayOrderFunc(parameter = {}) {
  return axios({
    url: '/order/createRepayOrder',
    method: 'post',
    data: parameter
  })
}

export function getApplist(parameter = {}) {
  return axios({
    url: '/app/listALLSelect',
    method: 'post',
    data: parameter
  })
}
export function getRoleCode(parameter = {}) {
  return axios({
    url: '/role/selectRoleCode',
    method: 'post',
    data: parameter
  })
}

export function getListAdvertisingContentSelect(parameter = {}) {
  return axios({
    url: '/statistics/listAdvertisingContentSelect',
    method: 'post',
    data: parameter
  })
}
export function exportCompanyDayReportExcel1 (parameter = {}) {
  return axios({
    url: `/order/findNotReceiveAmountListExcel?startDate=${parameter.startDate}&endDate=${parameter.endDate}&appssid=${parameter.appssid}`,
    method: 'get',
    data: parameter,
    responseType:'blob'
  })
}
export function getChannelContentSelect(parameter = {}) {
  return axios({
    url: '/statistics/channelContentSelect',
    method: 'post',
    data: parameter
  })
}

export function getApplistExcludingSubApp(parameter = {}) {
  return axios({
    url: '/app/listALLSelectExcludingSubApp',
    method: 'post',
    data: parameter
  })
}

export function countLoanDataWithDateForApp(parameter = {}) {
  return axios({
    url: '/platform/order/countLoanDataWithDateForApp',
    method: 'post',
    data: parameter
  })
}

export function reborrowCountAll(parameter = {}) {
  return axios({
    url: '/order/reborrowCountAll',
    method: 'post',
    data: parameter
  })
}

export function getRepaymentReportRateReal(parameter = {}) {
  return axios({
    url: '/statistics/repaymentReportRateReal',
    method: 'post',
    data: parameter
  })
}

export function getRepaymentReportForDepositProfit(parameter = {}) {
  return axios({
    url: '/statistics/platform/repaymentReportForDepositProfit',
    method: 'post',
    data: parameter
  })
}

export function repaymentReportAmtRateReal(parameter = {}) {
  return axios({
    url: '/statistics/repaymentReportAmtRateReal',
    method: 'post',
    data: parameter
  })
}

export function getOrderDetailForCollection(parameter = {}) {
  return axios({
    url: '/order/detailForCollection',
    method: 'post',
    data: parameter
  })
}

export function getRepaymentReportForBeginDate(parameter = {}) {
  return axios({
    url: '/statistics/platform/repaymentReportForBeginDate',
    method: 'post',
    data: parameter
  })
}
export function getrepaymentReportForBeginDateRoi(parameter = {}) {
  return axios({
    url: '/statistics/platform/repaymentReportForBeginDateRoi',
    method: 'post',
    data: parameter
  })
}

export function getLoanOrderList(parameter = {}) {
  return axios({
    url: '/order/loanOrderList',
    method: 'post',
    data: parameter
  })
}

export function getPendingOrderList(parameter = {}) {
  return axios({
    url: '/order/pendingOrderlist',
    method: 'post',
    data: parameter
  })
}

export function getOverdueList(parameter = {}) {
  return axios({
    url: '/order/overdueList',
    method: 'post',
    data: parameter
  })
}

export function getRepayPlanList(parameter = {}) {
  return axios({
    url: '/repayPlan/list',
    method: 'post',
    data: parameter
  })
}

export function getExamineLogList(parameter = {}) {
  return axios({
    url: '/examine/log/list',
    method: 'post',
    data: parameter
  })
}

export function getCollectionLogList(parameter = {}) {
  return axios({
    url: '/collectionLog/list',
    method: 'post',
    data: parameter
  })
}

export function getOrderNumberList(parameter = {}) {
  return axios({
    url: '/orderNumberInfo/selectByOrderInfoId',
    method: 'post',
    data: parameter
  })
}

export function getOrderImageList(parameter = {}) {
  return axios({
    url: '/orderImage/selectByOrderInfoId',
    method: 'post',
    data: parameter
  })
}


export function getAddressBookList(parameter = {}) {
  return axios({
    url: '/customer/addressBook',
    method: 'post',
    data: parameter
  })
}

export function allowLending(parameter = {}) {
  return axios({
    url: '/order/lending',
    method: 'post',
    data: parameter
  })
}

export function getRepayRecordList(parameter = {}) {
  return axios({
    url: '/repayPlan/repayRecordList',
    method: 'post',
    data: parameter
  })
}

export function getRepayFlowList(parameter = {}) {
  return axios({
    url: '/repayPlan/repayFlowList',
    method: 'post',
    data: parameter
  })
}

export function getRepayRecordListV2(parameter = {}) {
  return axios({
    url: '/repayPlan/repayRecordListV2',
    method: 'post',
    data: parameter
  })
}

export function getRepaymentReport(parameter = {}) {
  if (useMock()) return Promise.resolve(mockRepaymentReport)
  return axios({
    url: '/statistics/repaymentReport',
    method: 'post',
    data: parameter
  })
}

export function downRepaymentReportExcel(parameter) {
  return axios({
    url: '/statistics/repaymentReportExcel',
    method: 'get',
    data: parameter
  })
}

export function paymentsLink(parameter = {}) {
  return axios({
    url: '/order/paymentsLink',
    method: 'post',
    data: parameter
  })
}

export function repayStatusCheck(parameter = {}) {
  return axios({
    url: '/platform/order/repaymentStatusCheck',
    method: 'post',
    data: parameter
  })
}

export function reductionLateFee(parameter = {}) {
  return axios({
    url: '/order/reductionLateFee',
    method: 'post',
    data: parameter
  })
}

export function repayOfflineAll(parameter = {}) {
  return axios({
    url: '/order/repayOfflineAll',
    method: 'post',
    data: parameter
  })
}

export function getPlatformLoanOrderList(parameter = {}) {
  return axios({
    url: '/platform/order/loanOrderList',
    method: 'post',
    data: parameter
  })
}

export function getModifyCollectorOrderList(parameter = {}) {
  return axios({
    url: '/platform/order/modifyCollectorOrderList',
    method: 'post',
    data: parameter
  })
}

export function getPaydetailOrderList(parameter = {}) {
  return axios({
    url: '/order/paydetailOrderList',
    method: 'post',
    data: parameter
  })
}

export function getRepayOrderList(parameter = {}) {
  return axios({
    url: '/order/repayOrderList',
    method: 'post',
    data: parameter
  })
}

export function getPlatformAllOrderList(parameter = {}) {
  return axios({
    url: '/platform/order/allOrderList',
    method: 'post',
    data: parameter
  })
}

export function getPlatformCrossAllOrderList(parameter = {}) {
  return axios({
    url: '/platform/order/crossOrderList',
    method: 'post',
    data: parameter
  })
}

export function getAllOrderListSummary(parameter = {}) {
  return axios({
    url: '/platform/order/allOrderListSummary',
    method: 'post',
    data: parameter
  })
}

export function getDetectVerify(parameter = {}) {
  return axios({
    url: '/platform/order/detectVerify',
    method: 'get',
    params: parameter
  })
}

export function getBtcVerify(parameter = {}) {
  return axios({
    url: '/platform/order/btcVerify',
    method: 'get',
    params: parameter
  })
}

export function getOrderContractContract(parameter = {}) {
  return axios({
    url: '/orderContract/queryContract',
    method: 'get',
    params: parameter
  })
}
export function getOrderContractContractSum(parameter = {}) {
  return axios({
    url: '/orderContract/queryContractSum',
    method: 'get',
    params: parameter
  })
}
export function getLoanAccount(parameter = {}) {
  return axios({
    url: '/orderContract/queryLoanAccount',
    method: 'get',
    params: parameter
  })
}
export function getDebtor(parameter = {}) {
  return axios({
    url: '/orderContract/queryDebtor',
    method: 'get',
    params: parameter
  })
}
export function getOrder(parameter = {}) {
  return axios({
    url: '/orderContract/queryOrder',
    method: 'get',
    params: parameter
  })
}
export function getOrderAmountSituation(parameter = {}) {
  return axios({
    url: '/orderContract/queryOrderAmountSituation',
    method: 'post',
    params: parameter
  })
}
export function getPlatformPendingOrderlist(parameter = {}) {
  return axios({
    url: '/platform/order/pendingOrderlist',
    method: 'post',
    data: parameter
  })
}

export function getPlatformOverdueList(parameter = {}) {
  return axios({
    url: '/platform/order/overdueList',
    method: 'post',
    data: parameter
  })
}

export function countPlatformLoanDataWithDate(parameter = {}) {
  return axios({
    url: '/platform/order/countLoanDataWithDate',
    method: 'post',
    data: parameter
  })
}
export function convertDataAdgroupNameDelivery(parameter = {}) {
  return axios({
    url: '/statistics/convertDataAdgroupNameDelivery',
    method: 'post',
    data: parameter
  })
}

export function countOrderRepayData(parameter = {}) {
  return axios({
    url: '/platform/order/countOrderRepayData',
    method: 'post',
    data: parameter
  })
}

export function getPlatformRepaymentReport(parameter = {}) {
  if (useMock()) return Promise.resolve(mockRepaymentReport)
  return axios({
    url: '/statistics/platform/repaymentReport',
    method: 'post',
    data: parameter
  })
}

export function getRepaymentReportForAmount(parameter = {}) {
  return axios({
    url: '/statistics/platform/repaymentReportForAmount',
    method: 'post',
    data: parameter
  })
}

export function getRepaymentReportForAmountReal(parameter = {}) {
  return axios({
    url: '/statistics/platform/repaymentReportForAmountReal',
    method: 'post',
    data: parameter
  })
}

export function getRepaymentReportRate(parameter = {}) {
  return axios({
    url: '/statistics/repaymentReportRate',
    method: 'post',
    data: parameter
  })
}

export function getTransformingDataList(parameter = {}) {
  return axios({
    url: '/statistics/transformingDataList',
    method: 'post',
    data: parameter
  })
}


export function extendOffline(parameter = {}) {
  return axios({
    url: '/order/extendOffline',
    method: 'post',
    data: parameter
  })
}

export function modifyCollector(parameter = {}) {
  return axios({
    url: '/order/modifyCollector',
    method: 'post',
    data: parameter
  })
}

export function countLoanDataWithDate(parameter = {}) {
  return axios({
    url: '/order/countLoanDataWithDate',
    method: 'post',
    data: parameter
  })
}

export function reborrowCount(parameter = {}) {
  return axios({
    url: '/order/reborrowCount',
    method: 'post',
    data: parameter
  })
}

export function reborrowCountForSubmit(parameter = {}) {
  return axios({
    url: '/order/reborrowCountBySubmitDate',
    method: 'post',
    data: parameter
  })
}

export function getOverdueReportRate(parameter = {}) {
  if (useMock()) return Promise.resolve(mockRepaymentReport)
  return axios({
    url: '/statistics/overdueReportRate',
    method: 'post',
    data: parameter
  })
}

export function downOverdueReportExcel(parameter = {}) {
  return axios({
    url: '/statistics/overdueReportRateExcel',
    method: 'get',
    data: parameter
  })
}

export function getPlatformPartRepayOrderList(parameter = {}) {
  return axios({
    url: '/platform/order/partRepayList',
    method: 'post',
    data: parameter
  })
}

export function partRepayOfflineAll(parameter = {}) {
  return axios({
    url: '/order/partRepayOfflineAll',
    method: 'post',
    data: parameter
  })
}

export function getRefundTradeFlowList(parameter = {}) {
  return axios({
    url: '/order/refundTradeFlowList',
    method: 'post',
    data: parameter
  })
}

export function refundTrade(parameter = {}) {
  return axios({
    url: '/order/refundTrade',
    method: 'post',
    data: parameter
  })
}

export function editOrderStatusForTest(parameter = {}) {
  return axios({
    url: '/order/test/modifyOrderStatus',
    method: 'post',
    data: parameter
  })
}

export function clearOrderForTest(parameter) {
  return axios({
    url: '/order/test/clearOrderData',
    method: 'post',
    data: parameter
  })
}

export function updateOrderStatusByAdmin(parameter) {
  return axios({
    url: '/orderByAdmin/updateOrderStatusByAdmin',
    method: 'post',
    data: parameter
  })
}

export function orderReset(parameter) {
  return axios({
    url: '/order/orderReset',
    method: 'post',
    data: parameter
  })
}
export function orderDeductionFee(parameter) {
  return axios({
    url: '/order/orderDeductionFee',
    method: 'post',
    data: parameter
  })
}

export function clearRedisOrderData(parameter) {
  return axios({
    url: '/order/test/clearRedisOrderData',
    method: 'post',
    data: parameter
  })
}

export function getAppAllCountForDate(parameter = {}) {
  return axios({
    url: '/statistics/appAllCountForDate',
    method: 'post',
    data: parameter
  })
}

export function getAppAllCount(parameter = {}) {
  return axios({
    url: '/statistics/appAllCount',
    method: 'post',
    data: parameter
  })
}

export function getconvertDataAdgroupName(parameter = {}) {
  return axios({
    url: '/statistics/convertDataAdgroupName',
    method: 'post',
    data: parameter
  })
}

export function getlistAdvertisingContentSelect(parameter = {}) {
  return axios({
    url: '/statistics/listAdvertisingContentSelect',
    method: 'post',
    data: parameter
  })
}


export function getConvertData(parameter = {}) {
  return axios({
    url: '/statistics/convertData',
    method: 'post',
    data: parameter
  })
}


// 渠道源
export function getconvertDataChannel(parameter = {}) {
  return axios({
    url: '/statistics/convertDataChannel',
    method: 'post',
    data: parameter
  })
}


export function getConvertInstallData(parameter = {}) {
  return axios({
    url: '/statistics/convertInstallData',
    method: 'post',
    data: parameter
  })
}

export function getConvertRealData(parameter = {}) {
  return axios({
    url: '/statistics/convertRealData',
    method: 'post',
    data: parameter
  })
}

export function getAppAllCountPartner(parameter = {}) {
  return axios({
    url: '/statistics/appAllCountPartner',
    method: 'post',
    data: parameter
  })
}

export function getMedias(parameter = {}) {
  return axios({
    url: '/statistics/medias',
    method: 'post',
    data: parameter
  })
}

export function getOrderAllCount(parameter = {}) {
  return axios({
    url: '/statistics/orderAllCount',
    method: 'post',
    data: parameter
  })
}

export function getReApplyOrderCount(parameter = {}) {
  return axios({
    url: '/platform/order/reApplyOrderCount',
    method: 'post',
    data: parameter
  })
}

export function getOrderCountByLoanCount(parameter = {}) {
  return axios({
    url: '/order/countOrderByLoanCount',
    method: 'post',
    data: parameter
  })
}

export function getRepaymentYYReportForBeginDate(parameter = {}) {
  return axios({
    url: '/statistics/platform/repaymentYYReportForBeginDate',
    method: 'post',
    data: parameter
  })
}

export function collectionCountByDay(parameter = {}) {
  return axios({
    url: '/collectionReplaceTask/collectionCountByDay',
    method: 'post',
    data: parameter
  })
}

export function collectionPerformanceByDay(parameter = {}) {
  return axios({
    url: '/collectionReplaceTask/collectionPerformanceByDay',
    method: 'post',
    data: parameter
  })
}

export function collectionCountTotalByDay(parameter = {}) {
  return axios({
    url: '/collectionReplaceTask/collectionCountTotalByDay',
    method: 'post',
    data: parameter
  })
}

export function collectionPerformanceTotalByDay(parameter = {}) {
  return axios({
    url: '/collectionReplaceTask/collectionPerformanceTotalByDay',
    method: 'post',
    data: parameter
  })
}

export function getAppAllCountForAppssid(parameter = {}) {
  return axios({
    url: '/statistics/appAllCountForAppssid',
    method: 'post',
    data: parameter
  })
}

export function updateOverdueDaysById(orderInfoId, overduedays) {
  return axios({
    url: '/order/updateOverdueDaysById?orderInfoId=' + orderInfoId + '&overdueDays=' + overduedays,
    method: 'post'
  })
}

export function getJsonData(parameter = {}) {
  return axios({
    url: '/order/test/getJsonData',
    method: 'get',
    params: parameter,
    responseType: 'blob' // 设置响应类型为blob
  })
}


export function getallOrderList(parameter = {}) {
  return axios({
    url: '/repayLinkLog/allOrderList',
    method: 'post',
    data: parameter
  })
}


export function repaymentReportForProduct(parameter = {}) {
  return axios({
    url: '/statistics/platform/repaymentReportForProduct',
    method: 'post',
    data: parameter
  })
}

export function repaymentReportForQuota(parameter = {}) {
  return axios({
    url: '/statistics/platform/repaymentReportForQuota',
    method: 'post',
    data: parameter
  })
}

export function findAllProductRiskNo(parameter = {}) {
  return axios({
    url: '/statistics/platform/findAllProductRiskNo',
    method: 'post',
    data: parameter
  })
}

export function netProfitList(parameter = {}) {
  return axios({
    url: '/dataManager/netProfitList',
    method: 'post',
    data: parameter
  })
}

export function getSmsInfo(parameter = {}) {
  return axios({
    url: '/smsTrade/list',
    method: 'post',
    data: parameter
  })
}

export function getSmsInfoSum(parameter = {}) {
  return axios({
    url: '/smsTrade/getSmsInfoSum',
    method: 'post',
    data: parameter
  })
}

export function getRemarksList(parameter = {}) {
  return axios({
    url: '/smsTrade/getRemarks',
    method: 'post',
    data: parameter
  })
}

export function queryRepaymentRateLineChart(parameter = {}) {
  return axios({
    url: '/platform/collectionTask/queryRepaymentRateLineChart',
    method: 'post',
    data: parameter
  })
}

export function getRepayNotLoanProductInfo(parameter = {}) {
  return axios({
    url: '/repayNotLoan/list',
    method: 'post',
    data: parameter
  })
}

export function queryRiskScoreOrderInfo(parameter = {}) {
  return axios({
    url: '/platform/order/queryRiskScoreOrderInfo',
    method: 'post',
    data: parameter
  })
}

export function queryRiskScoreSumOrderInfo(parameter = {}) {
  return axios({
    url: '/platform/order/queryRiskScoreSumOrderInfo',
    method: 'post',
    data: parameter
  })
}

export function getRiskModelVersion(parameter = {}) {
  return axios({
    url: '/platform/order/queryRiskModelVersion',
    method: 'post',
    data: parameter
  })
}

export function queryApplyAmtOrderInfo(parameter = {}) {
  return axios({
    url: '/platform/order/queryApplyAmtOrderInfo',
    method: 'post',
    data: parameter
  })
}

export function queryApplyAmtSumOrderInfo(parameter = {}) {
  return axios({
    url: '/platform/order/queryApplyAmtSumOrderInfo',
    method: 'post',
    data: parameter
  })
}

export function getConvertDataMonitoringAlarm(parameter = {}) {
  return axios({
    url: '/traffic/getProductOperationInfo',
    method: 'post',
    data: parameter
  })
}

export function getSumConvertDataMonitoringAlarm(parameter = {}) {
  return axios({
    url: '/traffic/getProductSumOperationInfo',
    method: 'post',
    data: parameter
  })
}

export function getCollectionAvgTaskInfo(parameter = {}) {
  return axios({
    url: '/order/queryCollectionAvgTaskInfo',
    method: 'post',
    data: parameter
  })
}